import {
  MarkingCodesKmStatus,
  MarkingCodesPackagingType,
} from "../../../common/api/markingCodesReportApi";

// Ключи переводов статусов КМ — общие для формы создания и предпросмотра отчёта
export const KM_STATUS_LABEL_KEYS: Record<MarkingCodesKmStatus, string> = {
  ISSUED: "documents_file_upload.code_status_issued",
  INFLICTED: "documents_file_upload.code_status_inflicted",
  IN_CIRCULATION: "documents_file_upload.code_status_in_circulation",
  WITHDRAWN_FROM_CIRCULATION: "documents_file_upload.code_status_withdrawn",
  PRE_SALE: "NewCheque.PRE_SALE",
  AGGREGATED: "marking_codes.status_aggregated",
  DEAGGREGATED: "marking_codes.status_deaggregated",
};

export const PACKAGING_LABEL_KEYS: Record<MarkingCodesPackagingType, string> = {
  CONSUMER: "marking_codes.km_type_consumer",
  GROUP: "marking_codes.km_type_group",
};
